/**
 * 비회원 [견적 요청하기] 때 만든 앞면 미리보기 그림 보관 키(G12). 임시 작업(draft-storage)과 같은 상품별 localStorage 라
 * 견적 요청 화면이 같은 기기에서 읽어 보여 주고, 요청이 끝나면 임시 작업과 함께 지운다.
 */
export const draftPreviewKey = (productId: string): string =>
  `customize-draft-preview:${productId}`;

/** <img src> 에 그대로 쓰므로 이미지 data URL 만 받는다 — 그 밖의 값은 깨진 보관본으로 본다. */
const IMAGE_DATA_URL = /^data:image\/(?:webp|jpeg|png);base64,[A-Za-z0-9+/=]+$/;

export const saveDraftPreview = (productId: string, dataUrl: string): void => {
  try {
    localStorage.setItem(draftPreviewKey(productId), dataUrl);
  } catch {
    // 보관 실패(용량 등)는 요청 흐름을 막지 않는다 — 요청 화면이 글 요약만 보여 준다.
  }
};

/** 이미지 data URL 이 아니면 null 이고 지운다. */
export const loadDraftPreview = (productId: string): string | null => {
  try {
    const raw = localStorage.getItem(draftPreviewKey(productId));
    if (raw === null) return null;
    if (IMAGE_DATA_URL.test(raw)) return raw;
    localStorage.removeItem(draftPreviewKey(productId));
    return null;
  } catch {
    return null;
  }
};

export const clearDraftPreview = (productId: string): void => {
  try {
    localStorage.removeItem(draftPreviewKey(productId));
  } catch {
    // 무시
  }
};
